/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PointNextIcon = /*#__PURE__*/ createSvgIcon(
  'PointNextIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.77.5v0H7.788a1.206 1.206 0 01.132.01 2.163 2.163 0 011.211.544c.646.585 1.02 1.644.638 3.44l-.001.005a136.737 136.737 0 01-.591 2.481h7.989a2.13 2.13 0 11-.023 4.24H13.93c.032.047.063.095.09.145.372.65.322 1.403.276 1.837a17.938 17.938 0 01-.823 3.345A2.8 2.8 0 0110.59 18.5H6.591c-.44 0-.927 0-1.512-.24-.546-.224-1.144-.64-1.904-1.38H1a.5.5 0 01-.5-.5V8.29a.5.5 0 01.5-.5h1.52c.635 0 1.07-.175 1.438-.508.39-.353.733-.912 1.106-1.746l.004-.01 2.25-4.74A.5.5 0 017.77.5zm3.73 9.72h5.67c.02 0 .039.001.058.003a1.13 1.13 0 10.014-2.246l-.052-.497v.5H8.54a.5.5 0 01-.486-.62l.09-.362.209-.862c.16-.666.344-1.432.438-1.852.338-1.592-.044-2.229-.332-2.49a1.147 1.147 0 00-.401-.234L5.974 5.95c-.386.863-.797 1.577-1.344 2.073-.57.517-1.255.767-2.11.767H1.5v7.09h1.88a.5.5 0 01.354.146c.788.79 1.318 1.142 1.724 1.309.394.161.708.165 1.152.165h4a1.8 1.8 0 001.914-1.264l.004-.012c.358-1.018.618-2.069.776-3.136.043-.423.047-.881-.15-1.228-.168-.294-.563-.64-1.654-.64a.5.5 0 010-1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default PointNextIcon;
